import React from 'react';
import Card from '../Card';
import NoHayProps from '../NoHayProps';
import './styles.css';

function ListaPropiedades({allProps, propiedades}) {
    const listaPropiedades = allProps || propiedades || [];

    return (
        <div className='contGralListaP'>
            <div className='contListaP'>
                {
                    listaPropiedades[0] ?
                    listaPropiedades.filter(Boolean).map(p => {
                        return (
                            <div className='cont-card' key={p._id}>
                                <Card className='card' key={p._id}
                                    id={p._id}
                                    tituloPublicacion={p.tituloPublicacion}
                                    tipoPropiedad={p.tipoPropiedad}
                                    ubicacion={p.ubicacion}
                                    operacion={p.operacion}
                                    ofertas={p.ofertas}
                                    moneda={p.moneda}
                                    precio={p.precio}
                                    imagenes={p.imagenes}
                                    dormitorios={p.dormitorios}
                                    cantCocheras={p.cantCocheras}
                                    supTotal={p.supTotal}
                                    supDescubierta={p.supDescubierta}
                                    ambientes={p.ambientes}
                                    supCubierta={p.supCubierta}
                                    supSemiCub={p.supSemiCub}
                                    baños={p.baños}
                                    estadoActual={p.estadoActual}                               
                                />
                            </div>
                        )
                    }) : (
                        <div className='no-props'>
                            <NoHayProps/>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default ListaPropiedades
